import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Card, Spinner, EmptyState } from "@/components/bits";
import { ScrollText, ChevronDown } from "lucide-react";

function displayName(a) {
  return a.user_name || (a.user_email || "").split("@")[0] || "—";
}

const ACTION_LABELS = {
  OPEN_JOB_DETAIL: "Buka Detail Claim",
  CONFIRM_SPK: "Konfirmasi SPK",
  AUTO_CREATE_PART_ORDER: "PO Sparepart Dibuat Otomatis",
  CONFIRM_RECEIVING: "Konfirmasi Penerimaan Part",
  INSTALL_PART: "Part Terpasang",
  SUPPLIER_ASSIGN: "Supplier Ditentukan",
  ADD_SUPPLIER: "Tambah Supplier",
  EDIT_SUPPLIER: "Ubah Supplier",
  UPLOAD_SPK: "Upload SPK",
  RESET_TRANSACTIONS: "Reset Data Transaksi",
};
function actionLabel(a) {
  return ACTION_LABELS[a] || (a || "").replace(/_/g, " ");
}

function AuditRow({ a }) {
  const [open, setOpen] = useState(false);
  const t = a.timestamp ? new Date(a.timestamp) : null;
  return (
    <>
      <tr
        className="border-t border-gray-100 cursor-pointer hover:bg-gray-50"
        onClick={() => setOpen((v) => !v)}
        data-testid={`audit-row-${a.id}`}
      >
        <td className="px-3 py-2 whitespace-nowrap text-gray-500">{t ? t.toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit" }) : "—"}</td>
        <td className="px-3 py-2 font-medium text-gray-900">{displayName(a)}</td>
        <td className="px-3 py-2 font-medium">{actionLabel(a.action)}</td>
        <td className="px-3 py-2 font-mono-data text-xs text-gray-600 max-w-[220px] truncate">{a.entity_ref || "—"}</td>
        <td className="px-3 py-2 text-right"><ChevronDown size={15} className={`inline transition-transform ${open ? "rotate-180" : ""} text-gray-400`} /></td>
      </tr>
      {open && (
        <tr className="bg-gray-50/60" data-testid={`audit-detail-${a.id}`}>
          <td colSpan={5} className="px-4 py-3">
            <div className="grid sm:grid-cols-2 gap-x-8 gap-y-1 text-xs">
              <Detail label="User" value={displayName(a)} />
              <Detail label="Email" value={a.user_email} />
              <Detail label="Role" value={(a.role || "").toUpperCase()} />
              <Detail label="Waktu" value={t ? t.toLocaleString("id-ID") : "—"} />
              <Detail label="Action" value={actionLabel(a.action)} />
              <Detail label="Kode" value={a.action} />
              <Detail label="Entity" value={a.entity} />
              <Detail label="Ref" value={a.entity_ref} />
              {a.before != null && <Detail label="Old Value" value={JSON.stringify(a.before)} />}
              {a.after != null && <Detail label="New Value" value={JSON.stringify(a.after)} />}
            </div>
          </td>
        </tr>
      )}
    </>
  );
}

function Detail({ label, value }) {
  if (value === undefined || value === null || value === "") return null;
  return (
    <div className="flex gap-2">
      <span className="text-gray-400 min-w-[70px]">{label}</span>
      <span className="font-medium text-gray-800 break-all">{String(value)}</span>
    </div>
  );
}

export default function AuditLog() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/audit").then((r) => setRows(r.data)).finally(() => setLoading(false)); }, []);

  return (
    <div>
      <PageHeader title="Audit Log" subtitle="Klik baris untuk melihat detail lengkap (user, role, waktu, nilai lama/baru)." />
      {loading ? <Spinner /> : rows.length === 0 ? <EmptyState title="Belum ada aktivitas" icon={ScrollText} /> : (
        <Card className="overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-gray-50 text-gray-500 text-xs uppercase">
                <tr>
                  <th className="text-left px-3 py-2">Waktu</th>
                  <th className="text-left px-3 py-2">User</th>
                  <th className="text-left px-3 py-2">Action</th>
                  <th className="text-left px-3 py-2">Ref</th>
                  <th className="px-3 py-2" />
                </tr>
              </thead>
              <tbody>
                {rows.map((a) => <AuditRow key={a.id} a={a} />)}
              </tbody>
            </table>
          </div>
        </Card>
      )}
    </div>
  );
}
